export default {"src":"/_next/static/media/youtube-logo.e6809ab5.svg","height":34,"width":48,"blurWidth":0,"blurHeight":0};